import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Section, Inner, SectionHeader, SectionTitle, SectionSubtitle, Divider, fadeInUp } from '../styles/v2.styled';

const SERVICE_ITEMS = [
  { href: '/Courses', label: 'AI 교육', desc: '생성형 AI와 자동화 실습', color: '#0d9488' },
  { href: '/Courses', label: '빅데이터', desc: '데이터 분석과 시각화', color: '#2563eb' },
  { href: '/Courses', label: 'VR/AR', desc: '몰입형 콘텐츠 제작', color: '#7c3aed' },
  { href: '/Courses', label: '3D 모델링', desc: '3D 그래픽·콘텐츠 제작', color: '#9333ea' },
  { href: '/MyClassroom', label: '내 강의실', desc: '수강 과정 이어보기', color: '#d97706' },
  { href: '/Schedule', label: '일정', desc: '강의 일정 확인', color: '#0891b2' },
  { href: '/Download', label: '자료실', desc: '학습 자료 다운로드', color: '#dc2626' },
  { href: '/Help', label: '고객센터', desc: '문의와 공지 확인', color: '#4f46e5' },
];

const Bg = styled(Section)`
  background: ${({ theme }) => theme.colors.neutral[50]};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const ItemCard = styled(Link)`
  display: block;
  min-height: 120px;
  padding: 20px;
  background: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  text-decoration: none;
  animation: ${fadeInUp} 0.5s ease both;
  animation-delay: ${({ $idx }) => $idx * 0.04}s;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &::before {
    content: '';
    display: block;
    width: 34px;
    height: 3px;
    border-radius: 2px;
    background: ${({ $color }) => $color};
    margin-bottom: 18px;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.08);
    border-color: ${({ $color }) => $color};
  }
`;

const ItemLabel = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.typography.fontFamily.semibold};
  font-size: 1rem;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.neutral[900]};
  margin-bottom: 6px;
`;

const ItemDesc = styled.span`
  display: block;
  font-size: 0.86rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral[500]};
`;

function ServiceGrid() {
  return (
    <Bg $py="72px" $pyMobile="48px">
      <Inner>
        <SectionHeader>
          <Divider $center />
          <SectionTitle>학습 서비스</SectionTitle>
          <SectionSubtitle>과정 탐색부터 수강 관리까지 필요한 기능을 빠르게 이동하세요.</SectionSubtitle>
        </SectionHeader>

        <Grid>
          {SERVICE_ITEMS.map((item, i) => (
            <ItemCard to={item.href} key={`${item.label}-${i}`} $idx={i} $color={item.color}>
              <ItemLabel>{item.label}</ItemLabel>
              <ItemDesc>{item.desc}</ItemDesc>
            </ItemCard>
          ))}
        </Grid>
      </Inner>
    </Bg>
  );
}

export default ServiceGrid;
